var grecaptcha;
function Form() {
	this.init();
}

Form.prototype.init = function () {
	$('form.ajax').submit( function(e) {
		e.preventDefault();
		var f = $(e.target);
		$.ajax({
			type: 'POST',
			url: f.attr('action'),
			data: f.serialize(),
			dataType: 'json',
			success: function (data) {
				if (data.status===0) {
					//walidacja formularza	
					$('p.error').empty();
					if ($('form.ajax input[type="checkbox"]:checked').length === 0 || !$('form.ajax input[type="email"]').val()) {
						if (!$('p.error').hasClass('-visible')) {
							$('p.error').addClass('-visible');
						}
						if (!$('form.ajax input[type="email"]').val()) {
							$('p.error').append('<p>Enter your email address!</p>');
							if (!$('form.ajax input[type="email"]').hasClass('input-error')) {
								$('form.ajax input[type="email"]').addClass('input-error');
							}
						}
						if ($('form.ajax input[type="checkbox"]:checked').length === 0) {
							$('p.error').append('<p>Select at least one option!</p>');
							if (!$('form.ajax input[type="checkbox"] + span').hasClass('checkbox-error')) {
								$('form.ajax input[type="checkbox"] + span').addClass('checkbox-error');
							}
						} else {
							if ($('form.ajax input[type="checkbox"] + span').hasClass('checkbox-error')) {
								$('form.ajax input[type="checkbox"] + span').removeClass('checkbox-error');
							}
						}
					} else {
						if (data.code.email) {
							if (!$('form.ajax input[type="email"]').hasClass('input-error')) {
								$('form.ajax input[type="email"]').addClass('input-error');
							}
							if (!$('p.error').hasClass('-visible')) {
								$('p.error').addClass('-visible');
							}
							$('p.error').append('<p>'+data.code.email+'</p>');
						} else {
							$('form.ajax input[type="email"]').removeClass('input-error');
						}
						$('form.ajax input[type="checkbox"] + span').removeClass('checkbox-error');
					}
				}
				else if (data.status==1) {
					$('body').addClass('-transition');
					setTimeout(function() {
						window.location.href = data.redirect;
					}, 500);
				}
			}
		});
	});

	//formularz rejestracji
	$('.register-overlay form').submit( function(e) {
		e.preventDefault();
		var f = $(e.target);
		$.ajax({
			type: 'POST',
			url: f.attr('action'),
			data: f.serialize(),
			dataType: 'json',
			success: function (data) {
				//walidacja zwraca bledy
				if (data.fails) {
					f.find('.-input-error').removeClass('-input-error');
					f.find('.error').removeClass('error');
					if (data.errors) {
						$.each(data.errors, function(k, i) {
							var id = k;
							f.find('[name="'+id+'"]').closest('.input-container').find('.form__error').text(i[0]);
							f.find('[name="'+id+'"]').closest('.input-container').addClass('-input-error');
							f.find('[name="'+id+'"]').addClass('error');
						});
					}
					var first_error = $('.-input-error div.form__error').first();
					var el = $(first_error).closest('.body-overlay.-active');
					//el.scrollTop(0);
					//var top = $(first_error).closest('.-input-error')[0].offsetTop;
					//var getBoundingClientRect = $(first_error).closest('.-input-error')[0].getBoundingClientRect();
					//var top = getBoundingClientRect.top - getBoundingClientRect.height;
					var top = 0;
					setTimeout(function(e){
						if (data.step==1)
							top = $(first_error).closest('.-input-error')[0].offsetTop;
						else
							top = $(first_error).closest('.-input-error').parent()[0].offsetTop + $(first_error).closest('.-input-error')[0].offsetTop + 20;
						//console.log("Top: " + $(first_error).closest('.-input-error')[0].offsetTop );
						//console.log("Top 2: " + top);
						el.scrollTop( top );
					}, 50);
					//reset captcha
					if (grecaptcha!==undefined)
						grecaptcha.reset();
				} else {
					if (data.step==1) {
						//przejscie z korku 1 na 2
						$('.register-step1').addClass('-hidden');
						$('.register-step2').addClass('-visible');
						$('.body-overlay.-active').scrollTop(0);
					} else {
						//utworzono konto
						if (data.logged) {
							//inny komunikat
							if (data.message) {
								$('.register-thankyou-overlay .body-overlay-wrapper .form-message').html(data.message);
							}
							$('.register-overlay').removeClass('-active');
							$('.register-thankyou-overlay').addClass('-active');
							// window.location.href = "/profiles/edit";
						}
					}
				}
			}
		});
	});

	// czyszczenie bledow po zmianie wartosci
	$('form input, form radio, form checkbox, .w-checkbox-input').on('change',function() {
		$(this).removeClass('error');
		$(this).closest('.input-container').removeClass('-input-error');
		var parent = $(this).parent();
		parent.removeClass('error').removeClass('-input-error');
		parent.find('.errorinfo').removeClass('-active');
	});
};

$(document).ready(function(){
	form = new Form();
});